import React from 'react'
import { HtmlContent } from 'utils'
import {ReactComponent as PakychLogo} from '../../../../../assets/icons/Pakych.svg'

import styles from '../styles/check_algorithm_component.module.scss'

const Step = ({ title, description, image_type, subtitle }) => {
  return (
    <div className={styles.check_algorithm_component__item}>
      <div className={styles.check_algorithm_component__item_title_wrapper}>
        <h3 className={styles.check_algorithm_component__item_title}>{title}</h3>
        <div className={styles.check_algorithm_component__item_subtitle}>
          {subtitle}
        </div>
      </div>
      <div className={styles.check_algorithm_component__item_content}>
        <HtmlContent content={description} className={styles.check_algorithm_component__item_content_text} />
        {
          image_type === 'pakych'
            ? <div className={styles.check_algorithm_component__item_content_icon}>
              <PakychLogo/>
            </div>
            : null
        }
      </div>
    </div>
  )
}

export default Step